import { render } from "./MatchBracket.vue?vue&type=template&id=79f1932c&scoped=true"
import script from "./MatchBracket.vue?vue&type=script&lang=js"
export * from "./MatchBracket.vue?vue&type=script&lang=js"

import "./MatchBracket.vue?vue&type=style&index=0&id=79f1932c&lang=css"
import "./MatchBracket.vue?vue&type=style&index=1&id=79f1932c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f1932c"]])

export default __exports__